module.exports = __webpack_public_path__ + "static/media/down2.73c3bb69.jpg";